var map = {
	"./ANGOLA - Luanda.png": 77759,
	"./Afganistan - Kabul.png": 32304,
	"./Albaania - Tirana.png": 53692,
	"./Alžeeria - Alžiiri.png": 74102,
	"./Ameerika Ühendriigid - Washington.png": 6271,
	"./Andorra - Andorra la Vella.png": 59951,
	"./Antigua ja Barbuda - Saint John_s.png": 5836,
	"./Araabia Ühendemiraadid - Abu Dhabi.png": 53068,
	"./Argentiina - Buenos Aires.png": 78158,
	"./Armeenia - Jerevan.png": 6586,
	"./Aserbaijan - Bakuu.png": 92288,
	"./Austraalia - Canberra.png": 20335,
	"./Austria - Viin.png": 75958,
	"./Bahama - Nassau.png": 21575,
	"./Bahrein - Manama.png": 26242,
	"./Bangladesh - Dhaka.png": 86644,
	"./Barbados - Bridgetown.png": 16699,
	"./Belau - Ngerulmud.png": 63334,
	"./Belgia - Brüssel.png": 83193,
	"./Belize_i - Belmopan.png": 91374,
	"./Benin - Porto-Novo.png": 60509,
	"./Bhutan - Thimphu.png": 29399,
	"./Birma - Naypyidaw.png": 18687,
	"./Boliivia - La Paz, Sucre.png": 95364,
	"./Bosnia ja Hertsegoviina - Sarajevo.png": 5537,
	"./Botswana - Gaborone.png": 55406,
	"./Brasiilia - Brasilia.png": 70138,
	"./Brunei - Bandar Seri Begawan.png": 87204,
	"./Bulgaaria - Sofia.png": 87254,
	"./Burkina Faso - Ouagadougou.png": 34716,
	"./Burundi - Gitega.png": 62294,
	"./Cabo Verde - Praia.png": 93524,
	"./Colombia - Bogota.png": 37796,
	"./Congo Vabariik - Brazzaville.png": 27878,
	"./Costa Rica - San Jose.png": 89172,
	"./Djibouti - Djibouti.png": 12402,
	"./Domikaani Vabariik - Santo Domingo.png": 20921,
	"./Dominica - Roseau.png": 50729,
	"./Ecuador - Quito.png": 32598,
	"./Eesti - Tallinn.png": 3255,
	"./Egiptus - Kairo.png": 76008,
	"./Ekvatoriaal-Guinea - Malambo.png": 79141,
	"./El Salvador - San Salvador.png": 46062,
	"./Elevandiluurannik.png": 80544,
	"./Eritrea - Asmara.png": 33252,
	"./Etioopia - Addis Abeba.png": 86081,
	"./Fidži - Suva.png": 52301,
	"./Filipiinid - Manila.png": 25292,
	"./Gabon - Libreville.png": 25073,
	"./Gambia - Banjul.png": 38073,
	"./Ghana - Accra.png": 9700,
	"./Grenada - Saint George_s.png": 95719,
	"./Gruusia - Thibilisi.png": 3665,
	"./Guatemala - Guatemala City.png": 28918,
	"./Guinea - Conakry.png": 90665,
	"./Guinea-Bissau - Bissau.png": 32661,
	"./Guyana - Georgetown.png": 52494,
	"./Haiti - Port au Prince.png": 34565,
	"./Hiina - Peking.png": 31791,
	"./Hispaania - Madrid.png": 92450,
	"./Holland - Amsterdam.png": 59602,
	"./Honduras - Tegucigalpa.png": 72274,
	"./Horvaatia - Zagreb.png": 18814,
	"./Ida-Timor - Dili.png": 79768,
	"./Iirimaa - Dublin.png": 55011,
	"./Iisrael - Jeruusalemm.png": 38256,
	"./India - New Delhi.png": 95713,
	"./Indoneesia - Jakarta.png": 39309,
	"./Iraak - Bagdad.png": 90441,
	"./Iraani - Teheran.png": 1204,
	"./Island - Reykjavik.png": 78668,
	"./Itaalia - Rooma.png": 27168,
	"./Jaapan - Tokyo.png": 18138,
	"./Jakarta - Indoneesia.png": 49999,
	"./Jamaika - Kingston.png": 61840,
	"./Jeemen - Aden, Sanaa.png": 63122,
	"./Jordaania - Amman.png": 34569,
	"./Kambodža - Phnom Penh.png": 94874,
	"./Kamerun - Yaounde.png": 75133,
	"./Kanada - Ottawa.png": 38272,
	"./Kasasthan - Astana.png": 71038,
	"./Katar - Doha.png": 63549,
	"./Keenia - Nairobi.png": 6945,
	"./Kesk-Aafrika Vabariik - Bangui.png": 71888,
	"./Kiribati - Tarawa.png": 92110,
	"./Komoorid - Moroni.png": 8327,
	"./Kongo DV - Kinshasa.png": 40952,
	"./Kongo Vabariik - Brazzaville.png": 37189,
	"./Kosovo pealinn - Priština.png": 61155,
	"./Kreeka - Ateena.png": 95649,
	"./Kuuba - Havana.png": 3402,
	"./Kuveit.png": 4159,
	"./Kõrgõzstan - Biškek.png": 35758,
	"./Küpros - Nikosia.png": 43799,
	"./Laos - Vientiane.png": 52282,
	"./Leedu - Vilnius.png": 34903,
	"./Lesotho - Maseru.png": 47061,
	"./Libeeria - Monrovia.png": 63464,
	"./Liechtenstein - Vaduz.png": 55311,
	"./Liibanon - Beirut.png": 51523,
	"./Liibüa - Tripoli.png": 94960,
	"./Luxembourg - Luxembourg.png": 28697,
	"./Läti - Riia.png": 29815,
	"./Lõuna-Aafrika Vabariik - Pretoria, Kaplinn, Bloemfontein.png": 24211,
	"./Lõuna-Korea - Soul.png": 8655,
	"./Lõuna-Sudaan - Juba.png": 70609,
	"./Madagaskar - Antananarivo.png": 74035,
	"./Malaisia - Kuala Lumpur.png": 7937,
	"./Malawi - Lilongwe.png": 61426,
	"./Maldiivid - Male.png": 2137,
	"./Mali pealinn - Bamako.png": 28832,
	"./Malta - Valletta.png": 59197,
	"./Maroko - Rabat.png": 32621,
	"./Marshalli Saared - Majuro.png": 25409,
	"./Mauritaania - Nouakchott.png": 59434,
	"./Mauritius - Port Louis.png": 34706,
	"./Mehhiko - Mexico City.png": 97561,
	"./Mikroneesia - Palikir.png": 69444,
	"./Moldova - Chisinau.png": 25005,
	"./Monaco - Monaco.png": 5290,
	"./Mongoolia - Ulaanbataar.png": 98515,
	"./Montenegro - Podgorica.png": 68564,
	"./Mosambiik - Pluuto.png": 46285,
	"./Myanmar (Birma) - Naypyidaw.png": 78521,
	"./Namiibia pealinn - Windhoek.png": 17978,
	"./Nauru - Yaren.png": 18939,
	"./Nepal - Katmandu.png": 23742,
	"./Nicaragua - Managua.png": 81080,
	"./Nigeeria - Abuja.png": 7443,
	"./Niger - Niamey.png": 49631,
	"./Nigeri pealinn - Niamey.png": 46271,
	"./Norra - Oslo.png": 78425,
	"./Omaan - Masqat.png": 46986,
	"./Paapua Uus-Guinea - Port Moresby.png": 20232,
	"./Pakistan - Islamabad.png": 79426,
	"./Panama - Panama.png": 58464,
	"./Paraguay - Asuncion.png": 67484,
	"./Peruu - Lima.png": 70063,
	"./Pohja-Korea - Pyongyang.png": 39274,
	"./Poola - Varssavi.png": 79004,
	"./Portugal - Lissabon.png": 65035,
	"./Prantsusmaa - Pariis.png": 97832,
	"./Põhja-Makedoonia - Skopje.png": 70092,
	"./Qatar - Doha.png": 59273,
	"./Rootsi - Stockholm.png": 78001,
	"./Rumeenia - Bukarest.png": 21873,
	"./Rwanda - Kigali.png": 651,
	"./Saalomoni Saared - Honiara.png": 87794,
	"./Saint Kitts ja Nevis - Basseterre.png": 81798,
	"./Saint Lucia - Castries.png": 85825,
	"./Saint Vincent ja Grenadiinid - Kingstown.png": 93607,
	"./Saksamaa - Berliin.png": 65241,
	"./Sambia - Lusaka.png": 89513,
	"./Samoa - Apia.png": 76684,
	"./San Marino - San Marino.png": 64180,
	"./Sao Tome ja Principe - Sao Tome.png": 69979,
	"./Sarajevo.png": 5388,
	"./Saudi Araabia - Riyadh.png": 10300,
	"./Seisellid - Victoria.png": 41687,
	"./Senegal - Dakar.png": 469,
	"./Serbia - Belgrad.png": 65722,
	"./Sierra Leone - Freetown.png": 49180,
	"./Singapur - Singapur.png": 27871,
	"./Slovakkia - Bratislava.png": 24942,
	"./Sloveenia - Ljubljana.png": 62954,
	"./Somaalia - Muqdisho.png": 48147,
	"./Soome - Helsingi.png": 61435,
	"./Sri Lanka - Sri Jayewardenepura Kotte.png": 6432,
	"./Sudaan - Hartum.png": 55236,
	"./Suriname - Paramaribo.png": 87226,
	"./Suurbritannia - London.png": 63304,
	"./Sveits - Bern.png": 28040,
	"./Süüria - Damaskus.png": 57039,
	"./Taani - Kopenhaagen.png": 45357,
	"./Tadzikistan - Dusanbe.png": 47397,
	"./Tai - Bangkok.png": 29706,
	"./Tansaania - Todoma.png": 96672,
	"./Taškent.jpg": 21400,
	"./Togo - Lome.png": 84049,
	"./Tonga - Nukualofa.png": 44392,
	"./Trinidad ja Tobago - Port of Spain.png": 25834,
	"./Tsaad - Ndjamena.png": 33270,
	"./Tsehhi - Praha.png": 32019,
	"./Tsiili - Santiago.png": 61848,
	"./Tuneesia - Tunis.png": 53347,
	"./Tuvalu - Funafuti.png": 1671,
	"./Türgi - Ankara.png": 4425,
	"./Türkmenistan - Asgabat.png": 85857,
	"./USA lipu seos.png": 47650,
	"./Uganda - Kampala.png": 99774,
	"./Ukraina - Kiiev.png": 45818,
	"./Ungari - Budapest.png": 43505,
	"./Uruguay - Montevideo.png": 9494,
	"./Uus-Merema - Wellington.png": 32170,
	"./Valgevene - Minsk.png": 60579,
	"./Vanuatu - Port Vila.png": 41001,
	"./Vatikan - Vatikan.png": 6,
	"./Venemaa - Moskva.png": 95776,
	"./Venezuela - Caracas.png": 13348,
	"./Vietnam - Hanoi.png": 90579,
	"./Washington - USA pealinn.png": 8682,
	"./Zimbabwe - Harare.png": 8916,
	"./eSwatini - Mbabane.png": 86596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98055;